<aside class="sidebar" [class.collapsed]="collapsed">

  <!-- Zone logo — fond blanc, logo coloré -->
  <div class="sidebar-logo-area">
    @if (!collapsed) {
      <img src="assets/logo_ufolepSVGLight.svg" alt="Logo UFOLEP" class="sidebar-logo" />
    }
    @if (collapsed) {
      <img src="assets/logo_ufolepSVGLightMin.svg" alt="Logo UFOLEP" class="sidebar-logo-min" />
    }
  </div>

  <!-- Burger — en dessous du logo -->
  <div class="sidebar-burger-area">
    <button mat-icon-button (click)="onToggle()" aria-label="sidebar-toggle-bouton">
      <mat-icon>{{ collapsed ? 'menu' : 'menu_open' }}</mat-icon>
    </button>
  </div>

  <!-- Navigation -->
  <nav class="sidebar-nav">
    <a class="nav-item" routerLink="/dashboard" routerLinkActive="active"
      [matTooltip]="collapsed ? 'Accueil' : ''" matTooltipPosition="right"
      aria-label="sidebar-dashboard-lien">
      <mat-icon fontSet="material-icons-outlined">home</mat-icon>
      @if (!collapsed) {
        <span class="nav-label">Accueil</span>
      }
    </a>
    <a class="nav-item" routerLink="/sessions" routerLinkActive="active"
      [matTooltip]="collapsed ? 'Saisie du temps' : ''" matTooltipPosition="right"
      aria-label="sidebar-seances-lien">
      <mat-icon fontSet="material-icons-outlined">grid_on</mat-icon>
      @if (!collapsed) {
        <span class="nav-label">Saisie du temps</span>
      }
    </a>
    @if (isAdmin) {
      <a class="nav-item" routerLink="/admin/lieux" routerLinkActive="active"
        [matTooltip]="collapsed ? 'Lieux' : ''" matTooltipPosition="right"
        aria-label="sidebar-lieux-lien">
        <mat-icon fontSet="material-icons-outlined">location_on</mat-icon>
        @if (!collapsed) {
          <span class="nav-label">Lieux</span>
        }
      </a>
      <a class="nav-item" routerLink="/admin/activites" routerLinkActive="active"
        [matTooltip]="collapsed ? 'Activités' : ''" matTooltipPosition="right"
        aria-label="sidebar-activites-lien">
        <mat-icon fontSet="material-icons-outlined">local_activity</mat-icon>
        @if (!collapsed) {
          <span class="nav-label">Activités</span>
        }
      </a>
      <a class="nav-item" routerLink="/admin/dispositifs" routerLinkActive="active"
        [matTooltip]="collapsed ? 'Dispositifs' : ''" matTooltipPosition="right"
        aria-label="sidebar-dispositifs-lien">
        <mat-icon fontSet="material-icons-outlined">stadium</mat-icon>
        @if (!collapsed) {
          <span class="nav-label">Dispositifs</span>
        }
      </a>
      <a class="nav-item" routerLink="/admin/users" routerLinkActive="active"
        [matTooltip]="collapsed ? 'Utilisateurs' : ''" matTooltipPosition="right"
        aria-label="sidebar-utilisateurs-lien">
        <mat-icon fontSet="material-icons-outlined">group</mat-icon>
        @if (!collapsed) {
          <span class="nav-label">Utilisateurs</span>
        }
      </a>
    }
    <a class="nav-item" routerLink="/participants" routerLinkActive="active"
      [matTooltip]="collapsed ? 'Participants' : ''" matTooltipPosition="right"
      aria-label="sidebar-participants-lien">
      <mat-icon fontSet="material-icons-outlined">groups</mat-icon>
      @if (!collapsed) {
        <span class="nav-label">Participants</span>
      }
    </a>
  </nav>

  <!-- Footer — mode affichage -->
  <div class="sidebar-footer">
    <button class="theme-toggle"
      (click)="onThemeToggle()"
      [matTooltip]="collapsed ? 'Mode affichage' : ''"
      matTooltipPosition="right"
      aria-label="sidebar-theme-toggle-bouton">
      <mat-icon>{{ isDarkTheme ? 'light_mode' : 'dark_mode' }}</mat-icon>
      @if (!collapsed) {
        <span class="theme-toggle-label">
          <span class="theme-toggle-title">Mode affichage</span>
          <span class="theme-toggle-value">{{ isDarkTheme ? 'Clair' : 'Sombre' }}</span>
        </span>
      }
    </button>
  </div>

</aside>
